import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { login } from '../api';

export default function LoginPage() {
  const { loginUser } = useAuth();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await login(form);
      loginUser(res.data);
    } catch {
      setError('Invalid username or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #1E1B4B 0%, #312E81 50%, #1E1B4B 100%)',
    }}>
      <div style={{ width: '100%', maxWidth: 420, padding: '0 20px' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            width: 64, height: 64, borderRadius: 16,
            background: 'linear-gradient(135deg, #4F46E5, #06B6D4)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 16px', fontSize: 28,
          }}>🎯</div>
          <h1 style={{ color: 'white', fontSize: 28, marginBottom: 4 }}>Dream NEET</h1>
          <p style={{ color: '#A5B4FC', fontSize: 14 }}>Your NEET preparation platform</p>
        </div>
        <div className="card" style={{ borderRadius: 16, padding: 32 }}>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
            <div className="form-group">
              <label className="form-label">Username</label>
              <input className="form-input" value={form.username} placeholder="Enter your username"
                onChange={e => setForm(f => ({ ...f, username: e.target.value }))} required />
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <input className="form-input" type="password" value={form.password} placeholder="Enter your password"
                onChange={e => setForm(f => ({ ...f, password: e.target.value }))} required />
            </div>
            {error && <div className="error-msg" style={{ textAlign: 'center' }}>{error}</div>}
            <button className="btn btn-primary" type="submit" disabled={loading}
              style={{ justifyContent: 'center', padding: '12px', fontSize: 15, marginTop: 4 }}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>
        <p style={{ textAlign: 'center', color: '#A5B4FC', marginTop: 20, fontSize: 13 }}>
          crack<strong style={{color:'#06B6D4'}}>neet</strong>vd
        </p>
      </div>
    </div>
  );
}
